import { b as _slicedToArray } from './index-ded791f3.js';
import { useEffect, useRef } from 'react';
import isEqual from 'react-fast-compare';

var useCustomTabs = function useCustomTabs(tabs, uploadcare) {
  useEffect(function () {
    var customTabs = Object.entries(tabs || []);
    customTabs.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          implementation = _ref2[1];

      uploadcare.registerTab(name, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return implementation.apply(void 0, args.concat([uploadcare]));
      });
    });
  }, [tabs, uploadcare]);
};

var useDeepEffect = function useDeepEffect(effect, deps) {
  var ref = useRef(undefined);

  if (!isEqual(deps, ref.current)) {
    ref.current = deps;
  } // eslint-disable-next-line react-hooks/exhaustive-deps


  useEffect(effect, ref.current);
};

export { useDeepEffect as a, useCustomTabs as u };
